import { IContractFormikStatus } from 'services/templates/types';
import { contractTemplateFormInitialStatus } from '../form/contractTemplateFormInitialStatus';

export const sectionTemplateInitialStatus: IContractFormikStatus = {
  ...contractTemplateFormInitialStatus,
  minDepth: 2,
};
